var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5257 12.899H30.2503V12.8333H16.0003V19.1667H24.9485C23.6431 22.8535 20.1352 25.5 16.0003 25.5C10.754 25.5 6.50033 21.2464 6.50033 16C6.50033 10.7536 10.754 6.50001 16.0003 6.50001C18.422 6.50001 20.6252 7.41359 22.3028 8.90588L26.7812 4.42742C23.9534 1.79196 20.1708 0.166672 16.0003 0.166672C7.25637 0.166672 0.166992 7.25605 0.166992 16C0.166992 24.744 7.25637 31.8333 16.0003 31.8333C24.7443 31.8333 31.8337 24.744 31.8337 16C31.8337 14.9384 31.7244 13.9021 31.5257 12.899Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99219 8.63038L7.19423 12.4454C8.60181 8.96051 12.0107 6.50001 15.9999 6.50001C18.4216 6.50001 20.6249 7.41359 22.3024 8.90588L26.7809 4.42742C23.953 1.79196 20.1704 0.166672 15.9999 0.166672C9.91835 0.166672 4.64427 3.60013 1.99219 8.63038Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 31.8333C20.0897 31.8333 23.8058 30.2682 26.6154 27.723L21.715 23.5762C20.1253 24.7804 18.1493 25.5 15.9999 25.5C11.8817 25.5 8.38488 22.874 7.06755 19.2094L1.9043 23.1875C4.52471 28.3152 9.8463 31.8333 15.9999 31.8333Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5254 12.899H30.25V12.8333H16V19.1667H24.9482C24.3212 20.9376 23.182 22.4647 21.7127 23.577C21.7135 23.5762 21.7143 23.5762 21.715 23.5755L26.6155 27.7222C26.2687 28.0373 31.8333 23.9167 31.8333 16C31.8333 14.9384 31.7241 13.9021 31.5254 12.899Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.be6e345763faa19528e5a45a5e6edfa0.svg";
export { ForwardRef as ReactComponent };